import { PlessDialogServiceSub } from './../../../commons/kymw00/pless-dialog-service-sub';
import { CalcSupplyPlanService } from './api-services/calc-supply-plan.service';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import { GetSelectInfoService } from './api-services/get-select-info.service';
import { UpdateReportOutputDateService } from './api-services/update-report-output-date.service';
import { FileDownloadConfirmService } from './../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { KYMW1102SearchResultModel } from './vo/kymw1102-search-result.model';
import { PlessViewUtilsSub } from './../../../commons/kymw00/pless-view-utils-sub.service';
import { KYMW0300OutputModel } from '../../../commons/kymw03/kymw0300/vo/kymw0300-output.model';
import { KYMW0300InputModel } from '../../../commons/kymw03/kymw0300/vo/kymw0300-input.model';
import { KYMW0301InputModel } from '../../../commons/kymw03/kymw0301/vo/kymw0301-input.model';
import { KYMW0301OutputModel } from '../../../commons/kymw03/kymw0301/vo/kymw0301-output.model';
import { Component, OnInit, ViewChild, ViewEncapsulation, ElementRef, ViewContainerRef, HostListener, Renderer2 } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW1102Model } from './kymw1102.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { KYMW0300Component } from '../../../../../src/app/commons/kymw03/kymw0300/kymw0300.component';

import { FlexGrid, SelectionMode } from '@grapecity/wijmo.grid';
import { SaveFileService } from './api-services/save-file.service';
import { ComponentRef } from '@angular/core';
import { EventArgs } from '@grapecity/wijmo';
import { ClassCodeComboBoxComponent } from 'src/app/commons/kymw02/combo-box/class-code-combo-box/class-code-combo-box.component';
import { KYMW0300Model } from '../../../commons/kymw03/kymw0300/kymw0300.model';

/**
 * 新規取扱商品画面を管理するクラス
 *
 * @export KYMW1102Component
 * @class KYMW1102Component
 */
@Component({
  selector: 'app-kymw1102',
  templateUrl: 'kymw1102.component.html',
  styleUrls: ['kymw1102.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1102Component extends PlessViewHelperSub implements OnInit {

  //  親画面からの連携値
  param: any;

  // 親画面からの連携値（Pコードリスト）
  pcodeList: string[];

  kymw1102Model: KYMW1102Model = new KYMW1102Model();
  @ViewChild('dg_selectInfo', { static: true }) dg_selectInfo: FlexGrid;
  @ViewChild('txt_year', { static: true }) txt_year: ElementRef;
  @ViewChild('txt_pointplan', { static: true }) txt_pointplan: ElementRef;
  @ViewChild('closebtn', { static: true }) closebtn: ElementRef;
  @ViewChild('cmb_ClassCode', { static: true }) cmb_ClassCode: ClassCodeComboBoxComponent;

  /** 商品検索の参照 */
  public kymw0300ComponentRef: ComponentRef<any> = null;
  public kymw0300Component: KYMW0300Component;

  public kymw0300InputVO: KYMW0300InputModel = null;
  public kymw0300OutputVO: KYMW0300OutputModel = null;
  public kymw0300Model: KYMW0300Model = new KYMW0300Model();
  public kymw0301InputVO: KYMW0301InputModel = null;
  public kymw0301OutputVO: KYMW0301OutputModel = null;

  public viewFlag: boolean = <boolean>false;
  public selectedRow: number = <number>-1;

  //  ウィンドウを閉じる際の処理
  closeFunction: Function;
  selfManage: KYMW1102Model;

  /**
   *Creates an instance of KYMW1102Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1102Component
   */
  constructor(
    public dialogService: PlessDialogServiceSub,
    public kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private getSelectInfoService: GetSelectInfoService,
    private saveFileService: SaveFileService,
    private calcSupplyPlanService: CalcSupplyPlanService,
    public fileDownloadConfirmService: FileDownloadConfirmService,
    public updateReportOutputDateService: UpdateReportOutputDateService,
    public viewContainerRef: ViewContainerRef,
    public renderer: Renderer2,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1102Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1102';
    this.kymw1102Model.kymw1102Component = this;
    this.dg_selectInfo.selectionMode = SelectionMode.Row;

    // グリッドの初期選択行はなしとする
    this.dg_selectInfo.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dg_selectInfo.select(-1, -1);
      //  詳細データクリア
      this.clearDetail();
    });

    this.dg_selectInfo.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      const ht = this.dg_selectInfo.hitTest(e);
      if ((0 <= ht.row) && (0 == ht.col) && ht.target.className !== 'wj-cell wj-header wj-align-center') {
        document.getElementById(`cb_select_info_${ht.row}`).click();
      }
    });

    // 初期のフォーカス制御
    this.cmb_ClassCode.elementRef.nativeElement.children[0].focus();

    // 親画面から受け取ったPコードリストが1件以上の場合
    if(!PlessViewUtilsSub.isEmptyArray(this.pcodeList)) {
      // 受け取ったPコードリストをリクエストデータに設定
      const vo: KYMW0300OutputModel = new KYMW0300OutputModel();
      vo.pcodeList = this.pcodeList;
      // API実施・取得した情報を画面に反映
      this.getSelectInfoService.execute(this.kymw1102Model, vo);
    }
  }

  /**
   * 検索ボタン押下イベント
   *
   * @param event 押下時イベント
   */
  public eventSeach_CLICKHandler(event: Event): void {
    if (this.kymw0300InputVO === null || this.viewFlag) {
      this.kymw0300InputVO = new KYMW0300InputModel();
    }

    this.selectedRow = -1;

    if (this.kymw0300InputVO === null) {
      this.kymw0300InputVO = new KYMW0300InputModel();
    }
    // 企画関連条件を表示しない（企画検索フラグ:0）
    this.kymw0300InputVO.catalogSearchFlg = 0;

    // 商品検索画面(モーダル)を表示する。
    const componentRef = this.dialogService.openModal(KYMW0300Component);
    const instance = componentRef.componentInstance as KYMW0300Component;
    instance.parent = this;
    instance.setInterfaceParam(this.kymw0300InputVO);
    instance.setKYMW0300Parameter = (outputVO: KYMW0300OutputModel) => this.setKYMW0300Parameter(outputVO);

    instance.closeFunction = ()=>{
      componentRef.close();
    }

  }

  /**
   * 表示ボタン押下イベント
   *
   * @param event 押下時イベント
   */
  public eventView_CLICKHandler(event: Event): void {
    if (!this.kymw1102Model.admit) {
      // 部門かバイヤーが選定されているのか判断
      if (this.isEmpty(this.kymw1102Model.classCode) && this.isEmpty(this.kymw1102Model.buyerCode)) {
        // メッセージ表示
        this.dialogService.openAlertGetMessage('E0148', ['部門若しくはバイヤー'], null);
        return;
      }
    }

    this.selectedRow = -1;

    //  必須チェック
    if (this.isEmpty(this.kymw1102Model.buyerCode)
      && this.isEmpty(this.kymw1102Model.classCode)
      && !this.kymw1102Model.admit) {
      this.dialogService.openAlertGetMessage('E0143');
      return;
    }
    this.viewFlag = true;
    this.doSearch(true);
  }

  /**
   * 一覧データグリッド行選択イベント
   *
   * @param event 選択時イベント
   */
  public eventDg_SelectInfo_CHANGEHandler(event: Event): void {
    if (this.selectedRow >= 0) {
      //  入力された企画回等を保存する
      this.kymw1102Model.setProjectInfo(this.selectedRow,
        this.kymw1102Model.kikakumonth,
        this.kymw1102Model.kikakukai,
        this.kymw1102Model.pointplan,
        this.kymw1102Model.supplyPlan);
    }

    //  選択行番号
    const row: number = this.dg_selectInfo.selection.row;
    let item;
    if (row >= 0) {
      item = this.kymw1102Model.returnSelectInfoIndi(row);
    } else {
      return;
    }
    const boo: boolean = item.selectValue;
    this.kymw1102Model.pcode = item.PCode;
    this.kymw1102Model.itemcode = item.ItemCode;
    this.kymw1102Model.jancode = item.JanCode;
    this.kymw1102Model.goodsname = item.GuideGoodsName;
    this.kymw1102Model.standardsname = item.GuideStandardName;
    this.kymw1102Model.kikakumonth = item.proMonth;
    this.kymw1102Model.kikakukai = item.proKai;
    this.kymw1102Model.supplyprice = item.SupplyPriceStandard;
    this.kymw1102Model.pointplan = item.pointPlan;
    this.kymw1102Model.supplyPlan = item.supplyPlan;
    this.kymw1102Model.brandkbn = item.BrandTypeName;
    this.kymw1102Model.hozonkbn = item.LongkeepDivName;
    this.kymw1102Model.peacelength = item.PeaceSizeLength;
    this.kymw1102Model.peacewidth = item.PeaceSizeWidth;
    this.kymw1102Model.peaceheight = item.PeaceSizeHeight;
    this.kymw1102Model.caselength = item.CaseSizeLength;
    this.kymw1102Model.casewidth = item.CaseSizeWidth;
    this.kymw1102Model.caseheight = item.CaseSizeHeight;

    this.selectedRow = row;

  }

  /**
   * 点数計画テキストボックスフォーカインイベント
   *
   * @param event フォーカスインイベント
   */
  public eventTxt_PointPlan_FOCUS_INHandler(event: Event): void {
    // グリッドを一時非活性化
    this.updateDgridEnable(false);
  }

  /**
   * 点数計画テキストボックスフォーカスアウトイベント
   *
   * @param event フォーカスアウトイベント
   */
  public eventTxt_PointPlan_FOCUS_OUTHandler(event: Event): void {
    if (this.dg_selectInfo.selection.row === -1) {
      this.updateDgridEnable(true);
      return;
    }

    const item: KYMW1102SearchResultModel = this.kymw1102Model.returnSelectInfoIndi(this.dg_selectInfo.selection.row);

    const pointPlan: string = this.kymw1102Model.pointplan;
    if (this.isEmpty(pointPlan)) {
      this.updateDgridEnable(true);
      return;
    }
    //  入力された 供給価格（税込）に対する数値チェック
    if (this.isNaNString(pointPlan)) {
      //  数値以外は、メッセージを表示
      this.dialogService.openAlertGetMessage('W0010', ['点数計画'], null);
    }

    // 供給価格(税抜き)がNULLの場合、０で設定
    if (this.isEmpty(item.SupplyTaxWithoutStd)) {
      this.doCalc(this.kymw1102Model.setCalcData(pointPlan, '0'));
    } else {
      this.doCalc(this.kymw1102Model.setCalcData(pointPlan, item.SupplyTaxWithoutStd));
    }

  }

  /**
   * タブキーによるフォーカス先制御
   */
  public tabkey_focusEventHandler(event: KeyboardEvent): void {
    const target = event.target as HTMLElement;
    if (event.key !== 'Tab') {
      return;
    }
    const component = this;
    if (event.shiftKey) {
      // 逆行
      switch (target.id) {
        case 'txt_year':
          // 「点数計画」にフォーカスが当たるようにする
          this.txt_pointplan.nativeElement.focus();
          event.preventDefault();
          break;
        case 'cmb_ClassCode_sub':
          // 「閉じる」にフォーカスが当たるようにする
          setTimeout(() => {
            // preventDefaultが効かないため時差でフォーカス上書き
            component.closebtn.nativeElement.focus();
            event.preventDefault();
          }, 5);
          break;
      }
      return;
    }
    // 順行
    switch (target.id) {
      case 'txt_pointplan':
        // 「出力設定：年」にフォーカスが当たるようにする
        setTimeout(() => {
          // preventDefaultが効かないため時差でフォーカス上書き
          component.txt_year.nativeElement.focus();
          event.preventDefault();
        }, 5);
        break;
    }
  }

  /**
   * 出力ボタン押下イベント
   *
   * @param event 押下イベント
   */
  public eventOutput_CLICKHandler(event: Event): void {
    if (PlessViewUtilsSub.isEmptyArray(this.kymw1102Model.selectInfoList)) {
      return;
    }

    //  必須チェック
    if (this.isEmpty(this.kymw1102Model.year)) {
      this.dialogService.openAlertGetMessage('E0110', ['出力年'], null);
      return;
    }
    if (this.isEmpty(this.kymw1102Model.month)) {
      this.dialogService.openAlertGetMessage('E0110', ['企画回月'], null);
      return;
    }
    if (this.isEmpty(this.kymw1102Model.kai)) {
      this.dialogService.openAlertGetMessage('E0110', ['企画回回'], null);
      return;
    }
    if (this.isEmpty(this.kymw1102Model.chargeParson)) {
      this.dialogService.openAlertGetMessage('E0110', ['担当者'], null);
      return;
    }

    // 数値チェック
    if (this.isNaNString(this.kymw1102Model.year)) {
      //  数値以外は、メッセージを表示
      this.dialogService.openAlertGetMessage('W0010', ['出力年'], null);
      return;
    }

    if (this.selectedRow >= 0) {
      //  入力された企画回等を保存する
      this.kymw1102Model.setProjectInfo(this.selectedRow,
        this.kymw1102Model.kikakumonth,
        this.kymw1102Model.kikakukai,
        this.kymw1102Model.pointplan,
        this.kymw1102Model.supplyPlan);
    }

    let index: number = <number>0;
    let flag = false;
    const rowId: number = <number>0;
    const rowNo: Array<any> = new Array<any>();

    //  選択行のVOを取得
    const saveData: Array<any> = new Array<any>();
    const kymw1102vo: KYMW1102SearchResultModel = new KYMW1102SearchResultModel();

    for (const a of this.kymw1102Model.selectInfoList) {
      if (this.kymw1102Model.selectInfoList[index].selectValue) {
        flag = true;

        const selectRow = this.kymw1102Model.returnSelectInfoIndi(index);
        if (this.isEmpty(selectRow.PCode)) {
          kymw1102vo.PCodes.push('');
        } else {
          kymw1102vo.PCodes.push(selectRow.PCode);
        }
        if (this.isEmpty(selectRow.ClassDivNum)) {
          kymw1102vo.ClassDivNums.push('');
        } else {
          kymw1102vo.ClassDivNums.push(selectRow.ClassDivNum);
        }
        if (this.isEmpty(selectRow.ClassCode)) {
          kymw1102vo.ClassCodes.push('');
        } else {
          kymw1102vo.ClassCodes.push(selectRow.ClassCode);
        }
        if (this.isEmpty(selectRow.MiddleClassCode)) {
          kymw1102vo.MiddleClassCodes.push('');
        } else {
          kymw1102vo.MiddleClassCodes.push(selectRow.MiddleClassCode);
        }
        if (this.isEmpty(selectRow.SmallClassCode)) {
          kymw1102vo.SmallClassCodes.push('');
        } else {
          kymw1102vo.SmallClassCodes.push(selectRow.SmallClassCode);
        }
        if (this.isEmpty(selectRow.GuideGoodsName)) {
          kymw1102vo.GuideGoodsNames.push('');
        } else {
          kymw1102vo.GuideGoodsNames.push(selectRow.GuideGoodsName);
        }
        if (this.isEmpty(selectRow.GuideStandardName)) {
          kymw1102vo.GuideStandardNames.push('');
        } else {
          kymw1102vo.GuideStandardNames.push(selectRow.GuideStandardName);
        }
        if (this.isEmpty(selectRow.ConsumeTerm)) {
          kymw1102vo.ConsumeTerms.push('');
        } else {
          kymw1102vo.ConsumeTerms.push(selectRow.ConsumeTerm);
        }
        if (this.isEmpty(selectRow.ConsymeByDate)) {
          kymw1102vo.ConsymeByDates.push('');
        } else {
          kymw1102vo.ConsymeByDates.push(selectRow.ConsymeByDate);
        }
        if (this.isEmpty(selectRow.SetDiv)) {
          kymw1102vo.SetDivs.push('');
        } else {
          kymw1102vo.SetDivs.push(selectRow.SetDiv);
        }
        if (this.isEmpty(selectRow.LongKeepDiv)) {
          kymw1102vo.LongKeepDivs.push('');
        } else {
          kymw1102vo.LongKeepDivs.push(selectRow.LongKeepDiv);
        }
        if (this.isEmpty(selectRow.AssortTempDiv)) {
          kymw1102vo.AssortTempDivs.push('');
        } else {
          kymw1102vo.AssortTempDivs.push(selectRow.AssortTempDiv);
        }
        if (this.isEmpty(selectRow.ItemCode)) {
          kymw1102vo.ItemCodes.push('');
        } else {
          kymw1102vo.ItemCodes.push(selectRow.ItemCode);
        }
        if (this.isEmpty(selectRow.JanCode)) {
          kymw1102vo.JanCodes.push('');
        } else {
          kymw1102vo.JanCodes.push(selectRow.JanCode);
        }
        if (this.isEmpty(selectRow.BrandType)) {
          kymw1102vo.BrandTypes.push('');
        } else {
          kymw1102vo.BrandTypes.push(selectRow.BrandType);
        }
        if (this.isEmpty(selectRow.OrderClientCode)) {
          kymw1102vo.OrderClientCodes.push('');
        } else {
          kymw1102vo.OrderClientCodes.push(selectRow.OrderClientCode);
        }
        if (this.isEmpty(selectRow.MakerName)) {
          kymw1102vo.MakerNames.push('');
        } else {
          kymw1102vo.MakerNames.push(selectRow.MakerName);
        }
        if (this.isEmpty(selectRow.EbaseSpecCode)) {
          kymw1102vo.EbaseSpecCodes.push('');
        } else {
          kymw1102vo.EbaseSpecCodes.push(selectRow.EbaseSpecCode);
        }
        if (this.isEmpty(selectRow.PeaceSizeLength)) {
          kymw1102vo.PeaceSizeLengths.push('');
        } else {
          kymw1102vo.PeaceSizeLengths.push(selectRow.PeaceSizeLength);
        }
        if (this.isEmpty(selectRow.PeaceSizeWidth)) {
          kymw1102vo.PeaceSizeWidths.push('');
        } else {
          kymw1102vo.PeaceSizeWidths.push(selectRow.PeaceSizeWidth);
        }
        if (this.isEmpty(selectRow.PeaceSizeHeight)) {
          kymw1102vo.PeaceSizeHeights.push('');
        } else {
          kymw1102vo.PeaceSizeHeights.push(selectRow.PeaceSizeHeight);
        }
        if (this.isEmpty(selectRow.CaseSizeLength)) {
          kymw1102vo.CaseSizeLengths.push('');
        } else {
          kymw1102vo.CaseSizeLengths.push(selectRow.CaseSizeLength);
        }
        if (this.isEmpty(selectRow.CaseSizeWidth)) {
          kymw1102vo.CaseSizeWidths.push('');
        } else {
          kymw1102vo.CaseSizeWidths.push(selectRow.CaseSizeWidth);
        }
        if (this.isEmpty(selectRow.CaseSizeHeight)) {
          kymw1102vo.CaseSizeHeights.push('');
        } else {
          kymw1102vo.CaseSizeHeights.push(selectRow.CaseSizeHeight);
        }
        if (this.isEmpty(selectRow.RegistCatalogRound)) {
          kymw1102vo.RegistCatalogRounds.push('');
        } else {
          kymw1102vo.RegistCatalogRounds.push(selectRow.RegistCatalogRound);
        }
        if (this.isEmpty(selectRow.ClassNameKanji)) {
          kymw1102vo.ClassNameKanjis.push('');
        } else {
          kymw1102vo.ClassNameKanjis.push(selectRow.ClassNameKanji);
        }
        if (this.isEmpty(selectRow.MiddleClassNameKanji)) {
          kymw1102vo.MiddleClassNameKanjis.push('');
        } else {
          kymw1102vo.MiddleClassNameKanjis.push(selectRow.MiddleClassNameKanji);
        }
        if (this.isEmpty(selectRow.SmallClassNameKanji)) {
          kymw1102vo.SmallClassNameKanjis.push('');
        } else {
          kymw1102vo.SmallClassNameKanjis.push(selectRow.SmallClassNameKanji);
        }
        if (this.isEmpty(selectRow.SupplyPriceStandard)) {
          kymw1102vo.SupplyPriceStandards.push('');
        } else {
          kymw1102vo.SupplyPriceStandards.push(selectRow.SupplyPriceStandard);
        }
        if (this.isEmpty(selectRow.SupplyPriceSpecial1)) {
          kymw1102vo.SupplyPriceSpecial1s.push('');
        } else {
          kymw1102vo.SupplyPriceSpecial1s.push(selectRow.SupplyPriceSpecial1);
        }
        if (this.isEmpty(selectRow.SupplyPriceSpecial2)) {
          kymw1102vo.SupplyPriceSpecial2s.push('');
        } else {
          kymw1102vo.SupplyPriceSpecial2s.push(selectRow.SupplyPriceSpecial2);
        }
        if (this.isEmpty(selectRow.SupplyTaxWithoutStd)) {
          kymw1102vo.SupplyTaxWithoutStds.push('');
        } else {
          kymw1102vo.SupplyTaxWithoutStds.push(selectRow.SupplyTaxWithoutStd);
        }
        if (this.isEmpty(selectRow.SupplyTaxWithoutSpc1)) {
          kymw1102vo.SupplyTaxWithoutSpc1s.push('');
        } else {
          kymw1102vo.SupplyTaxWithoutSpc1s.push(selectRow.SupplyTaxWithoutSpc1);
        }
        if (this.isEmpty(selectRow.SupplyTaxWithoutSpc2)) {
          kymw1102vo.SupplyTaxWithoutSpc2s.push('');
        } else {
          kymw1102vo.SupplyTaxWithoutSpc2s.push(selectRow.SupplyTaxWithoutSpc2);
        }
        if (this.isEmpty(selectRow.CostPriceStandard)) {
          kymw1102vo.CostPriceStandards.push('');
        } else {
          kymw1102vo.CostPriceStandards.push(selectRow.CostPriceStandard);
        }
        if (this.isEmpty(selectRow.CostPriceSpecial1)) {
          kymw1102vo.CostPriceSpecial1s.push('');
        } else {
          kymw1102vo.CostPriceSpecial1s.push(selectRow.CostPriceSpecial1);
        }
        if (this.isEmpty(selectRow.CostPriceSpecial2)) {
          kymw1102vo.CostPriceSpecial2s.push('');
        } else {
          kymw1102vo.CostPriceSpecial2s.push(selectRow.CostPriceSpecial2);
        }
        if (this.isEmpty(selectRow.BrandTypeName)) {
          kymw1102vo.BrandTypeNames.push('');
        } else {
          kymw1102vo.BrandTypeNames.push(selectRow.BrandTypeName);
        }
        if (this.isEmpty(selectRow.AssortTempDivName)) {
          kymw1102vo.AssortTempDivNames.push('');
        } else {
          kymw1102vo.AssortTempDivNames.push(selectRow.AssortTempDivName);
        }
        if (this.isEmpty(selectRow.SetDivName)) {
          kymw1102vo.SetDivNames.push('');
        } else {
          kymw1102vo.SetDivNames.push(selectRow.SetDivName);
        }
        if (this.isEmpty(selectRow.LongkeepDivName)) {
          kymw1102vo.LongkeepDivNames.push('');
        } else {
          kymw1102vo.LongkeepDivNames.push(selectRow.LongkeepDivName);
        }
        if (this.isEmpty(selectRow.OrderClientName)) {
          kymw1102vo.OrderClientNames.push('');
        } else {
          kymw1102vo.OrderClientNames.push(selectRow.OrderClientName);
        }
        if (this.isEmpty(selectRow.proMonth)) {
          kymw1102vo.proMonths.push('');
        } else {
          kymw1102vo.proMonths.push(selectRow.proMonth);
        }
        if (this.isEmpty(selectRow.proKai)) {
          kymw1102vo.proKais.push('');
        } else {
          kymw1102vo.proKais.push(selectRow.proKai);
        }
        if (this.isEmpty(selectRow.pointPlan)) {
          kymw1102vo.pointPlans.push('');
        } else {
          kymw1102vo.pointPlans.push(selectRow.pointPlan);
        }
        if (this.isEmpty(selectRow.supplyPlan)) {
          kymw1102vo.supplyPlans.push('');
        } else {
          kymw1102vo.supplyPlans.push(selectRow.supplyPlan);
        }
        //  消費税区分
        if (this.isEmpty(selectRow.ConsumeTaxDiv)) {
          kymw1102vo.ConsumeTaxDivs.push('');
        } else {
          kymw1102vo.ConsumeTaxDivs.push(selectRow.ConsumeTaxDiv);
        }
        //  消費税率
        if (this.isEmpty(selectRow.ConsumeTaxRate)) {
          kymw1102vo.ConsumeTaxRates.push('');
        } else {
          kymw1102vo.ConsumeTaxRates.push(selectRow.ConsumeTaxRate);
        }
      }

      index++;
    }
    if (!flag) {
      this.dialogService.openAlertGetMessage('E0105', ['候補商品'], null);
      return;
    }

    kymw1102vo.outputYear = this.kymw1102Model.year;
    kymw1102vo.outputMonth = this.kymw1102Model.month;
    kymw1102vo.outputKai = this.kymw1102Model.kai;
    kymw1102vo.outputChargePerson = this.kymw1102Model.chargeParson;

    // API呼び出し
    this.saveFileService.execute(this.kymw1102Model, kymw1102vo, (data: any) => {
      if (data != null && !this.isEmpty(data.FileName)) {
        // サーバファイル名の保存
        this.kymw1102Model.updateFileName(data);
        // ファイル名の設定
        const fileName = '新規取扱商品_' + PlessViewUtilsSub.formatedNowDate('YYYYMMDD_hhmmss') + '.zip';
        // ダウンロード
        this.fileDownloadConfirmService.show(data.FileName, fileName, true, null, (callback) => {
          this.updateReportOutputDateService.execute(this.kymw1102Model, kymw1102vo, () => {
            callback();
          });
        });
      }
    });
  }

  /**
   * 検索処理
   *
   * @param val true:表示ボタン押下時 false:検索ボタン押下時
   */
  public doSearch(val: boolean): void {

    //  詳細データクリア
    this.clearDetail();

    let vo: KYMW0300OutputModel = new KYMW0300OutputModel;
    if (val) {
      vo = this.setViewConditionVO();
    } else {
      vo = this.setSearchConditionVO();
    }
    this.getSelectInfoService.execute(this.kymw1102Model, vo);
  }

  /**
   * 検索条件設定
   *
   * @param outputVO 商品検索画面で設定した検索条件
   */
  public setKYMW0300Parameter(outputVO: KYMW0300OutputModel): void {
    // 検索条件を保持
    this.kymw0300InputVO = this.kymw0300Model.getKYMW0300SearchHistory(outputVO);

    //  新規取扱商品画面の検索条件をクリアする
    this.kymw1102Model.classCode = '';
    this.kymw1102Model.buyerCode = '';
    this.kymw1102Model.admit = false;
    this.viewFlag = false;

    //  検索処理を行う
    this.doSearch(false);

  }

  /**
   * 検索条件をセットする（検索ボタン押下時）
   *
   * @return 生成したVO
   */
  public setSearchConditionVO(): KYMW0300OutputModel {
    //  戻り値
    const returnSearchConditionVO: KYMW0300OutputModel = new KYMW0300OutputModel();

    returnSearchConditionVO.pcode = this.kymw0300InputVO.pcode;
    returnSearchConditionVO.itemCode = this.kymw0300InputVO.itemCode;
    returnSearchConditionVO.janCode = this.kymw0300InputVO.janCode;
    returnSearchConditionVO.makerName = this.kymw0300InputVO.makerName;
    returnSearchConditionVO.tagSearchType = this.kymw0300InputVO.tagSearchType;
    returnSearchConditionVO.goodsMarkSearchType = this.kymw0300InputVO.goodsMarkSearchType;
    returnSearchConditionVO.dataKbnFlg = this.kymw0300InputVO.dataKbnFlg;
    returnSearchConditionVO.goodsDiv = this.kymw0300InputVO.goodsDiv;
    returnSearchConditionVO.ordrClientCode = this.kymw0300InputVO.ordrClientCode;
    returnSearchConditionVO.ordrClientKanji = this.kymw0300InputVO.ordrClientKanji;
    returnSearchConditionVO.payeeClientCode = this.kymw0300InputVO.payeeClientCode;
    returnSearchConditionVO.payeeClientKanji = this.kymw0300InputVO.payeeClientKanji;
    returnSearchConditionVO.classCode = this.kymw0300InputVO.classCode;
    returnSearchConditionVO.middleClassCode = this.kymw0300InputVO.middleClassCode;
    returnSearchConditionVO.smallClassCode = this.kymw0300InputVO.smallClassCode;
    returnSearchConditionVO.registDateFrom = this.kymw0300InputVO.registDateFrom;
    returnSearchConditionVO.registDateTo = this.kymw0300InputVO.registDateTo;
    returnSearchConditionVO.updateDateFrom = this.kymw0300InputVO.updateDateFrom;
    returnSearchConditionVO.updateDateTo = this.kymw0300InputVO.updateDateTo;
    returnSearchConditionVO.admitStatus = this.kymw0300InputVO.admitStatus;
    returnSearchConditionVO.buyerCode = this.kymw0300InputVO.buyerCode;
    returnSearchConditionVO.guideGoodsNameList = this.kymw0300InputVO.guideGoodsNameList;
    returnSearchConditionVO.guideStandardNameList = this.kymw0300InputVO.guideStandardNameList;
    returnSearchConditionVO.coopCodeList = this.kymw0300InputVO.coopCodeList;
    returnSearchConditionVO.pcodeList = this.kymw0300InputVO.pcodeList;
    returnSearchConditionVO.itemcodeList = this.kymw0300InputVO.itemCodeList;
    returnSearchConditionVO.tagId = this.kymw0300InputVO.tagId;
    returnSearchConditionVO.goodsMark = this.kymw0300InputVO.goodsMark;
    //  業態区分（デイリー）
    returnSearchConditionVO.dutiesFormDailyList = this.kymw0300InputVO.duties;
    //  コープコードリスト保存
    this.kymw1102Model.setSelectedCoop(returnSearchConditionVO.coopCodeList, false);

    return returnSearchConditionVO;
  }

  /**
   * 検索条件をセットする（表示ボタン押下時）
   *
   * @return 生成したVO
   */
  public setViewConditionVO(): KYMW0300OutputModel {
    //  戻り値
    const returnSearchConditionVO: KYMW0300OutputModel = new KYMW0300OutputModel();

    returnSearchConditionVO.classCode = this.kymw1102Model.classCode;
    returnSearchConditionVO.buyerCode = this.kymw1102Model.buyerCode;
    if (this.kymw1102Model.admit) {
      returnSearchConditionVO.admitStatus = '1';
    } else {
      returnSearchConditionVO.admitStatus = '';
    }

    returnSearchConditionVO.pcode = '';
    returnSearchConditionVO.itemCode = '';
    returnSearchConditionVO.janCode = '';
    returnSearchConditionVO.makerName = '';
    returnSearchConditionVO.tagSearchType = '';
    returnSearchConditionVO.goodsMarkSearchType = '';
    returnSearchConditionVO.dataKbnFlg = false;
    returnSearchConditionVO.goodsDiv = '';
    returnSearchConditionVO.ordrClientCode = '';
    returnSearchConditionVO.ordrClientKanji = '';
    returnSearchConditionVO.payeeClientCode = '';
    returnSearchConditionVO.payeeClientKanji = '';
    returnSearchConditionVO.middleClassCode = '';
    returnSearchConditionVO.smallClassCode = '';
    returnSearchConditionVO.registDateFrom = '';
    returnSearchConditionVO.registDateTo = '';
    returnSearchConditionVO.updateDateFrom = '';
    returnSearchConditionVO.updateDateTo = '';

    returnSearchConditionVO.guideGoodsNameList = new Array<any>();
    returnSearchConditionVO.guideStandardNameList = new Array<any>();
    returnSearchConditionVO.coopCodeList = new Array<any>();
    returnSearchConditionVO.pcodeList = new Array<any>();
    returnSearchConditionVO.itemcodeList = new Array<any>();
    returnSearchConditionVO.tagId = new Array<any>();
    returnSearchConditionVO.goodsMark = new Array<any>();
    //  VOのリストに格納
    returnSearchConditionVO.dutiesFormDailyList = new Array<any>();
    returnSearchConditionVO.dutiesFormWeekly = null;
    returnSearchConditionVO.dutiesFormSpot = null;

    //  コープコードリスト保存
    this.kymw1102Model.setSelectedCoop(null, true);

    return returnSearchConditionVO;
  }

  /**
   * 計算処理
   *
     * @param value 計算元データ
   */
  public doCalc(kymw1102vo: KYMW1102SearchResultModel): void {
    this.calcSupplyPlanService.execute(this.kymw1102Model, kymw1102vo);
  }

  /**
   * 数値でないかどうかを判定する(String版)
   * [戻り値]true：数値ではない／false：数値
   *
     * @param value 判定する文字列
   */
  public isNaNString(value: string): boolean {
    const number = Number(value);
    return isNaN(number);
  }

  /**
   * データグリッド使用モード制御
   *
     * @param value True：使用可能、False：使用不可
   */
  public updateDgridEnable(value: boolean): void {
    this.dg_selectInfo.isDisabled = !value;
  }

  /**
   * 詳細情報クリア
   *
   */
  public clearDetail(): void {
    this.kymw1102Model.pcode = '';
    this.kymw1102Model.itemcode = '';
    this.kymw1102Model.jancode = '';
    this.kymw1102Model.goodsname = '';
    this.kymw1102Model.standardsname = '';
    this.kymw1102Model.kikakumonth = '';
    this.kymw1102Model.kikakukai = '';
    this.kymw1102Model.supplyprice = '';
    this.kymw1102Model.pointplan = '';
    this.kymw1102Model.supplyPlan = '';
    this.kymw1102Model.brandkbn = '';
    this.kymw1102Model.hozonkbn = '';
    this.kymw1102Model.peacelength = '';
    this.kymw1102Model.peacewidth = '';
    this.kymw1102Model.peaceheight = '';
    this.kymw1102Model.caselength = '';
    this.kymw1102Model.casewidth = '';
    this.kymw1102Model.caseheight = '';
  }

  private isEmpty(s: string): boolean {
    return PlessViewUtilsSub.isEmpty(s);
  }
}
